
import { AccountAPI } from "@/api/api-account";
import { AppEvents } from "@/control/app-events";
import { AuthController } from "@/control/auth";
import { Request } from "@/utils/request";
import { defineComponent, nextTick } from "vue";
import { useVModel } from "../../utils/vmodel";
import { FocusTrap } from "../../utils/focus-trap";

import QrcodeVue from 'qrcode.vue'

export default defineComponent({
  components: {
    QrcodeVue,
  },
  name: "TwoFactorEnableModal",
  emits: ["update:display"],
  props: {
    display: Boolean,
  },
  setup(props) {
    return {
      displayStatus: useVModel(props, "display"),
    };
  },
  data: function () {
    return {
      secret: "",
      uri: "",
      token: "",

      busy: false,
      error: "",
    };
  },
  methods: {
    autoFocus: function () {
      const elem = this.$el.querySelector(".auto-focus");
      if (elem) {
        setTimeout(() => {
          elem.focus();
        }, 200);
      }
    },

    open: function () {
      Request.Pending(
        "tfa-code-generate",
        AccountAPI.GenerateTwoFactorAuthentication()
      )
        .onSuccess((generatedTFA) => {
          this.token = "";
          this.secret = generatedTFA.secret;
          this.uri = generatedTFA.uri;
          this.displayStatus = true;
          this.autoFocus();
        })
        .onRequestError((err) => {
          Request.ErrorHandler()
            .add(401, "*", () => {
              AppEvents.Emit("unauthorized");
            })
            .handle(err);
        })
        .onUnexpectedError((err) => {
          console.error(err);
        });
    },

    close: function () {
      this.displayStatus = false;
    },

    escapeToClose: function (event) {
      if (event.key === "Escape") {
        this.close();
      }
    },

    stopPropagationEvent: function (e) {
      e.stopPropagation();
    },

    submit: function (e) {
      if (e) {
        e.preventDefault();
      }
      if (this.busy) {
        return;
      }
      this.busy = true;
      this.error = "";
      Request.Do(AccountAPI.SetupTwoFactorAuthentication(this.secret, this.token))
        .onSuccess(() => {
          this.busy = false;
          this.close();
          AuthController.CheckAuthStatus();
          AppEvents.ShowSnackBar(this.$t("Two factor authentication successfully enabled"));
        })
        .onCancel(() => {
          this.busy = false;
        })
        .onRequestError((err) => {
          this.busy = false;
          Request.ErrorHandler()
            .add(401, "*", () => {
              AppEvents.Emit("unauthorized");
            })
            .add(400, "ALREADY", () => {
              this.error = this.$t("Two factor authentication is already enabled for this account");
            })
            .add(400, "INVALID", () => {
              this.error = this.$t("Invalid one-time password");
            })
            .add(400, "INVALID_TFA_CODE", () => {
              this.error = this.$t("Invalid one-time password");
            })
            .add(400, "*", () => {
              this.error = this.$t("Bad request");
            })
            .add(500, "*", () => {
              this.error = this.$t("Internal server error");
            })
            .add("*", "*", () => {
              this.error = this.$t("Could not connect to the server");
            })
            .handle(err);
        })
        .onUnexpectedError((err) => {
          this.error = err.message;
          console.error(err);
          this.busy = false;
        });
    },
  },
  mounted: function () {
    this.$options.openH = this.open.bind(this);
    AppEvents.AddEventListener("tfa-enable-open", this.$options.openH);
    this.$options.focusTrap = new FocusTrap(this.$el, this.close.bind(this));
  },
  beforeUnmount: function () {
    AppEvents.RemoveEventListener("tfa-enable-open", this.$options.openH);
    this.$options.focusTrap.destroy();
  },
  watch: {
    display: function () {
      if (this.display) {
        this.$options.focusTrap.activate();
        nextTick(() => {
          this.$el.focus();
        });
      } else {
        this.$options.focusTrap.deactivate();
      }
    },
  },
});
